import * as THREE from 'three'

export const createCamera = () => new THREE.PerspectiveCamera(45, 16/9, 0.1, 10000)

export const createRenderTexture = () =>
  new THREE.WebGLRenderTarget( 16, 9, {
    minFilter: THREE.LinearFilter,
    magFilter: THREE.LinearFilter,
    format: THREE.RGBFormat
  } )

export const createScene3D = () => new THREE.Scene()

export const createObject3D = () => new THREE.Object3D()

export const createQuad = (mat) => {
  const geom = new THREE.BufferGeometry()
  const positions = [
    -1.0, -1.0, 0.0,
    1.0, -1.0, 0.0,
    -1.0, 1.0, 0.0,
    -1.0, 1.0, 0.0,
    1.0, -1.0, 0.0,
    1.0, 1.0, 0.0
  ]
  const uv = [
    0.0, 0.0,
    1.0, 0.0,
    0.0, 1.0,
    0.0, 1.0,
    1.0, 0.0,
    1.0, 1.0
  ]
  geom.addAttribute('position', new THREE.Float32BufferAttribute(positions, 3))
  geom.addAttribute('uv', new THREE.Float32BufferAttribute(uv, 2))
  return new THREE.Mesh(geom, mat || new THREE.MeshBasicMaterial({
    name: 'compose',
    color: '#000000',
    side: THREE.DoubleSide
  }))
}

export const createPlane = (width, height, segmentW, segmentH, mat) => {
  const geom = new THREE.PlaneGeometry(width, height, segmentW, segmentH)
  return new THREE.Mesh(geom, mat)
}

export const createCurvyPage = mat => {
  const geom = new THREE.PlaneGeometry(10, 14, 16, 1)
  return new THREE.Mesh(geom, mat || new THREE.MeshBasicMaterial({
    name: 'compose',
    color: '#ff5555',
    side: THREE.DoubleSide
  }))
}

export const createCoverPage = (matFront, matBack) => {
  const geom = new THREE.BoxGeometry(10, 14, 0.2)
  const defaultMat = new THREE.MeshBasicMaterial({
    name: 'compose',
    color: '#000000',
  })
  const mesh = new THREE.Mesh(geom, [defaultMat, defaultMat, defaultMat, defaultMat, matFront || defaultMat, matBack || defaultMat])
  geom.translate(5, 0, 0)
  mesh.position.x = -5
  return mesh
}

export const createSphere = () => new THREE.Mesh(new THREE.SphereGeometry(0.105,32,32), new THREE.MeshBasicMaterial({
  name: 'compose',
  color: '#000000',
  side: THREE.DoubleSide
}))

export const createDefaultTexture = () => {
  const loader = new THREE.TextureLoader()
  loader.crossOrigin = true
  return loader.load('https://threejs.org/examples/textures/758px-Canestra_di_frutta_(Caravaggio).jpg')
}

export const addGestureViewer = function (obj, dispatcher) {
  const initialProps = {
    rotation: { x: obj.rotation.x, y: obj.rotation.y },
    scale: { x: obj.scale.x, y: obj.scale.y, z: obj.scale.z }
  }
  const onDrag = e => {
    obj.rotation.y += e.movementX * 0.01
    obj.rotation.x += e.movementY * 0.01
  }
  const onWheel = e => {
    let zoom = -e.deltaY * 0.005
    if (obj.scale.x + zoom <= 0) zoom = 0
    obj.scale.x += zoom
    obj.scale.y += zoom
    obj.scale.z += zoom
  }
  dispatcher.addEventListener('mousedown', e => {
    dispatcher.addEventListener('mousemove', onDrag)
  })
  dispatcher.addEventListener('mouseup', e => {
    dispatcher.removeEventListener('mousemove', onDrag)
  })
  dispatcher.addEventListener('wheel', onWheel)
  window.addEventListener('keyup', e => {
    if (e.code !== 'KeyR') return
    obj.rotation.x = initialProps.rotation.x
    obj.rotation.y = initialProps.rotation.y
    obj.scale.x = initialProps.scale.x
    obj.scale.y = initialProps.scale.y
    obj.scale.z = initialProps.scale.z
  })
}

export const normalize = v => new THREE.Vector3(v.x, v.y, v.z).normalize()
export const multiply = (va, vb) => new THREE.Vector3(va.x, va.y, va.z).multiply(new THREE.Vector3(vb.x, vb.y, vb.z))


// WEBPACK FOOTER //
// ./src/scripts/helpers/3DEngineHelper.js